module.exports = __webpack_public_path__ + "static/media/20210411_174212_867_IMG_0579.5201f958.jpg";